import { createStyles, makeStyles } from "@material-ui/core/styles";

import { WHITE, BACKGROUND_COLOR, GRAY_SALT_SILVER, BLACK } from "constants/colors";

export default makeStyles(() =>
  createStyles({
    root: {
      backgroundColor: BACKGROUND_COLOR,
      width: "100%",
      height: "100vh",
      padding: 0,
      margin: 0,
    },
    gridContent: {
      padding: "0px 16px",
      backgroundColor: BACKGROUND_COLOR,
    },
    itemLeft: {
      width: "40px",
      marginRight: 16,
      "& > img": {
        width: "80%",
      },
    },
    itemRight: {
      width: "100%",
      color: "#CFD9E6",
      fontFamily: "Roboto",
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 14,
    },
    item: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-start",
      alignItems: "center",
      width: "100%",
      marginTop: "32px",
    },
    logo: {
      width: "90%",
      marginTop: "32px",
    },
    headerText: {
      fontFamily: "Roboto",
      display: "block",
      fontStyle: "normal",
      fontWeight: 300,
      color: "#CFD9E6",
      marginTop: "32px",
      fontSize: 16,
    },
    line: {
      padding: 0,
      margin: 0,
      marginTop: "40px",
      border: `1px solid ${GRAY_SALT_SILVER}`,
    },
    buttonLogin: {
      height: "auto",
      padding: "10px 16px",
      margin: "20px 0px 16px 0px",
      backgroundColor: "#363d47",
      border:"none",
      borderRadius: "32px",
      cursor: "pointer",
      outline: "none",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      color:WHITE,
      "&:hover,&:focus": {
        color: BLACK,
        backgroundColor: "#90caf9",
        border:"none",
      },
      "& > span": {
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: 14,
        lineHeight: "19px",
      },
    },   
  })
);
